export const azureADConfigsDEV = {
        clientId: "323673b1-11ce-4930-a1ae-c7fe95dffd49",
        tenantId: "4049701a-97e7-40c3-b85f-80db7b116671",
        authority: "https://login.microsoftonline.com/4049701a-97e7-40c3-b85f-80db7b116671"
}

export const azureADConfigsTEST = {
        clientId: "b897c1b6-f121-49be-a53d-08d6c09f888b",
        tenantId: "d2007bef-127d-4591-97ac-10d72fe28031",
        authority: "https://login.microsoftonline.com/d2007bef-127d-4591-97ac-10d72fe28031"
}


export const azureADConfigsPROD = {
        clientId: "b897c1b6-f121-49be-a53d-08d6c09f888b",
        tenantId: "d2007bef-127d-4591-97ac-10d72fe28031",
        authority: "https://login.microsoftonline.com/d2007bef-127d-4591-97ac-10d72fe28031"
}


export const tokenClaimScope = {
        devEnvScope: ["api://323673b1-11ce-4930-a1ae-c7fe95dffd49/elx-orders-app"],
        testEnvScope: ["api://b897c1b6-f121-49be-a53d-08d6c09f888b/SP_com-Italy"],
        prodEnvScop: ["api://b897c1b6-f121-49be-a53d-08d6c09f888b/SP_com-Italy"]
}
        
